<template>
	<div class="page">

					<div v-if="!profileData">
						<v-skeleton-loader
							type="card"
							class="mb-8"
						></v-skeleton-loader>
						<v-skeleton-loader
							type="card"
							class="mb-8"
						></v-skeleton-loader>
						<v-skeleton-loader type="card"></v-skeleton-loader>
					</div>
					<div v-else>
						<profile-avatar-card :profileData="profileData" />
						<profile-info
							:jobPosition="profileData.job_position"
							:teamName="
								profileData.team
									? profileData.team.name || ''
									: ''
							"
							:workersCount="
								profileData.team
									? profileData.team.users || 0
									: 0
							"
							class="mt-5"
						/>
						<profile-groups
							:key="`groups-${profileData.id}`"
							:userID="profileData.id"
							class="mt-5"
						/>
						<!-- <training-settings
							:key="`training-settings-${profileData.id}`"
							:userID="profileData.id"
							class="mt-5"
						/> -->
						<v-card outlined class="mt-6">
							<v-card-title>
								{{
									$vuetify.lang.t(
										"$vuetify.views.profile.publishedPosts"
									)
								}}
							</v-card-title>
							<v-card-text>
								<profile-user-posts
									:key="profileData.id"
									:userID="profileData.id"
								/>
							</v-card-text>
						</v-card>
					</div>

	</div>
</template>

<script>
import ProfileAvatarCard from "@/components/profile/ProfileAvatarCard";
import ProfileInfo from "@/components/profile/ProfileInfo";
import ProfileGroups from "@/components/profile/ProfileGroups";
// import TrainingSettings from "@/components/settings/TrainingSettings";
import ProfileUserPosts from "@/components/profile/ProfileUserPosts";

export default {
	components: {
		ProfileAvatarCard,
		ProfileInfo,
		ProfileGroups,
		// TrainingSettings,
		ProfileUserPosts,
	},

	props: {
		profileData: {
			type: [String, Object],
		},
	},
};
</script>

<style scoped>
.title-font {
	font-size: 16px;
}
</style>
